<template>
  <div>
    <ul class="grid-3x2 list-reset">
      <li
        class="flex items-center h-12"
        v-for="(incl, index) in displayingAmenities"
        :key="index"
      >
        <div class="flex-none pr-3">
          <template v-if="incl.type === 'extra'">
            <svg style="fill: currentColor" width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_dollar"></use>
            </svg>
          </template>
          <template v-else>
            <svg width="24" height="24">
              <use xlink:href="/img/sprite.svg#ic_success"></use>
            </svg>
          </template>
        </div>
        <div class="flex-1">{{ incl.name }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";

import { DIVE_CENTER_FACILITIES } from "../../helpers/constants";

export default {
  props: ["resortId"],
  data() {
    return {
      inclusions: [],
    };
  },
  computed: {
    orderedInclusions() {
      return orderBy(this.inclusions, ["order", "name"], ["asc", "asc"]);
    },
    displayingAmenities() {
      return [...this.included, ...this.extra];
    },
    included() {
      return this.orderedInclusions.filter((incl) => incl.type === "included");
    },
    extra() {
      return this.orderedInclusions.filter((incl) => incl.type === "extra");
    },
  },
  mounted() {
    window
      .fetchSupplierInfo(this.resortId)
      .then((res) => {
        if (res.inclusions.length === 0) {
          throw new Error();
        }

        this.inclusions = res.inclusions.filter(
          (incl) => incl.list_id !== DIVE_CENTER_FACILITIES
        );
      })
      .catch(() => {
        document
          .querySelector(".resort-original-resort-facilities")
          .classList.remove("hidden");
        document
          .querySelector(".resort-odyssey-resort-facilities")
          .classList.add("hidden");
      });
  },
};
</script>
